import { Loading, Notify } from 'notiflix';
import React, { createRef, useState } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { forgotPassword } from '../../data/api/auth/AuthRoutes';
import useAuth from '../../hooks/useAuth';
import validErrors from '../../hooks/validErrors';

const Login2 = ({
    codeWin,
    winData,
    handleClose
}) => {
    const { login, register } = useAuth();
    const [dataSection, setDataSection] = useState(1);

    const emailRef = createRef();
    const passwordRef = createRef();
    const sessionRef = createRef();

    const emailForgotRef = createRef();

    const nameRegisterRef = createRef();
    const emailRegisterRef = createRef();
    const documentRegisterRef = createRef();
    const phoneRegisterRef = createRef();
    const passwordRegisterRef = createRef();
    const passwordConfirmationRef = createRef();
    const agreeTermsRef = createRef();

    const handleLogin = async e => {
        e.preventDefault();
        const data = {
            email: emailRef.current.value,
            password: passwordRef.current.value,
            session: sessionRef.current.checked,
            codeWin: codeWin,
            winData: winData,
        }
        login(data);
    }

    const handleForgotPassword = async e => {
        e.preventDefault();
        Loading.hourglass();
        try {
            let email = emailForgotRef.current.value;
            const { data } = await forgotPassword({ 'email': email });

            if (data?.success) {
                Notify.success('Se ha enviado a tu correo un link para cambiar tu contraseña.');
                handleClose();
            }
        } catch (error) {
            validErrors(error);
        } finally {
            Loading.remove(3000);
        }
    }

    const handleRegister = async e => {
        e.preventDefault();

        const data = {
            name: nameRegisterRef.current.value,
            email: emailRegisterRef.current.value,
            document: documentRegisterRef.current.value,
            phone: phoneRegisterRef.current.value,
            password: passwordRegisterRef.current.value,
            password_confirmation: passwordConfirmationRef.current.value,
            agree_terms: agreeTermsRef.current.checked ? true : null,
            codeWin: codeWin,
            winData: winData,
        }

        register(data);
    }

    return (
        <LoginContent>
            <div className={`wrap-inner goto-${dataSection}`}>

                <div className="section" id="section1">
                    <div className="form form--login">
                        <div className='close' onClick={handleClose}><span>Cerrar X</span></div>
                        <h1 className="alpha">Ingresar</h1>
                        <p className='alpha-p'>Te damos la bienvenida a Fenabocol Org.</p>
                        <div>
                            <form className="form-wrap" onSubmit={handleLogin} noValidate>
                                <input id="email" className="inputbox email" type="text" placeholder="Correo" ref={emailRef} />
                                <input id="password" className="inputbox password" type="password" placeholder="Contraseña" ref={passwordRef} />
                                <div>
                                    <input
                                        id="stay-sign"
                                        name='stay-sign'
                                        type="checkbox"
                                        ref={sessionRef}
                                        defaultChecked
                                    />
                                    <label htmlFor="stay-sign">Mantener sesión iniciada</label>
                                </div>
                                <div><button type='submit' className="button">Ingresar <i className="fa-solid fa-rocket"></i></button></div>
                            </form>
                        </div>
                        <p>Tambien puedes ingresar con tu red social.</p>
                        <div className="social">
                            <a href="#" className="facebook"><i className="fa-brands fa-facebook-f"></i></a>
                            <a href="#" className="twitter"><i className="fa-brands fa-twitter"></i></a>
                            <a href="#" className="google"><i className="fa-brands fa-google"></i></a>
                        </div>
                        <p>¿No tienes cuenta? <a className="scroll" onClick={(e) => { e.preventDefault(); setDataSection(2) }}>Registrate aqui &raquo;</a></p>
                        <hr />
                        <p><a className="scroll" onClick={(e) => { e.preventDefault(); setDataSection(3) }}>¿Olvidaste la contraseña? &raquo;</a></p>
                    </div>
                </div>

                <div className="section" id="section2">
                    <div className="form form--signup">
                        <div className='close' onClick={handleClose}><span>Cerrar X</span></div>
                        <h1 className="alpha">Registrate Aqui!</h1>
                        <p>Ingresa tus datos para el registro</p>
                        <div>
                            <form className="form-wrap" onSubmit={handleRegister} noValidate>
                                <input id="name" className="inputbox name" type="text" placeholder="Nombre" ref={nameRegisterRef} />
                                <input id="email" className="inputbox email" type="text" placeholder="Correo" ref={emailRegisterRef} />
                                <input id="document" className="inputbox document" type="text" placeholder="Documento" ref={documentRegisterRef} />
                                <input id="phone" className="inputbox phone" type="text" placeholder="Telefono" ref={phoneRegisterRef} />
                                <input id="password" className="inputbox password" type="password" placeholder="Contraseña" ref={passwordRegisterRef} />
                                <input id="password_confirmation" className="inputbox password" type="password" placeholder="Confirma Contraseña" ref={passwordConfirmationRef} />
                                <div className='terms-container'>
                                    <input id="agree_terms" name='agree_terms' type="checkbox" ref={agreeTermsRef} defaultChecked />
                                    <label className='agree-terms' htmlFor="agree_terms"> Acepto los <Link to={'/terms-conditions'}>Terminos & Condiciones</Link> </label>
                                </div>
                                <div><button type='submit' className="button">Registrar <i className="fa-solid fa-rocket"></i></button></div>
                            </form>
                        </div>
                        <hr />
                        <p>O puedes registrarte con tu red social.</p>
                        <div className="social">
                            <a href="#" className="facebook"><i className="fa-brands fa-facebook-f"></i><span>Facebook</span></a>
                            <a href="#" className="twitter"><i className="fa-brands fa-twitter"></i><span>Twitter</span></a>
                            <a href="#" className="google"><i className="fa-brands fa-google"></i><span>Google</span></a>
                        </div>
                        <p><a className="scroll" onClick={(e) => { e.preventDefault(); setDataSection(1) }}>&laquo; Ingresa Aqui</a></p>
                    </div>
                </div>

                <div className="section" id="section3">
                    <div className="form form--login">
                        <div className='close' onClick={handleClose}><span>Cerrar X</span></div>
                        <h1 className="alpha">Olvidaste la clave?</h1>
                        <p>No te preocupes, puedes recuperarla, Ingresa tu correo.</p>
                        <div>
                            <form className="form-wrap" onSubmit={handleForgotPassword}>
                                <input id="email" className="inputbox email" type="text" placeholder="Correo" ref={emailForgotRef} />
                                <div><button type='submit' className="button">Enviar <i className="fa-solid fa-rocket"></i></button></div>
                            </form>
                        </div>
                        <hr />
                        <p><a className="scroll" onClick={(e) => { e.preventDefault(); setDataSection(1) }}>&laquo; Ingresar</a></p>
                    </div>
                </div>

            </div>
        </LoginContent>
    )
}

export default Login2

const LoginContent = styled.div`
    *,
    *:after,
    *:before {
        box-sizing: border-box;  
    }

    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;

    .wrap-inner {
        width: 300%;
        height: 100%;
        transition: transform 500ms cubic-bezier(1.000, 0.000, 0.000, 1.000);
        transform: translateX(0);
        -webkit-backface-visibility: hidden;
        overflow-y: scroll;
    }

    hr {
        height: 0;
        margin: .5rem 0;
        border: 0;
        border-top: 1px dashed #ddd;
    }

    

    .section {
        margin: 0;
        width: 33%;
        max-width: 100vw;
        height: 100%;
        padding: 1rem;
        display: inline-block;
        vertical-align: top;
        text-align: center;
    }

    .alpha {
        color: #333;
        padding: 0;
        margin: 0;
    }
    .alpha-p {
        margin: 0 0 1rem 0;
    }

    .form {
        min-width: 1rem;
        max-width: 50%;
        background: #fff;
        border-radius: 4px;
        padding: 2rem;
        text-align: center;
        margin: 5em auto;
        display: inline-block;
        position: relative;
        .close {
            position: absolute;
            top: .5rem;
            left: 1rem;
            z-index: 10000000;
            color: #AAA;
            transition: all .3s ease;
            &:hover {
                color: #1C1C1C;
                cursor: pointer;
                text-decoration: underline;
            }
        }
        @media (max-width: 768px) {
            margin: 0em auto;
            max-width: 100%;
        }
    }
    .form--signup {
        @media (max-width: 768px) {
            padding-bottom: 1rem;
            max-width: 100%;
            height: 110%;
            overflow-y: scroll;

        }
    }
    .form-wrap {
        margin: 0;
        padding: .1rem 0;
        .terms-container {
            margin: .5rem 0 1.3rem 0;
            a {
                color: #3498db;
            }
        }
        .agree-terms {
            color: #000;
        }
    }
    .form-wrap .inputbox {
        border: 1px solid #eaedf2;
        border-radius: 3px;
        padding: 1rem 0 1rem 1.2rem;
        width: 44%;
        outline: none;
        margin-bottom: .5rem;
        font-family: inherit;
        @media (max-width: 768px) {
            width: 100%;
        }
    }
    .form--login .form-wrap .inputbox {
        width: 88%;
    }
    .form-wrap .name,
    .form-wrap .email,
    .form-wrap .document,
    .form-wrap .phone,
    .form-wrap .password {
        background: #eaedf2 no-repeat;
        margin: 0 .2rem .5rem .2rem;
    }
    .form-wrap .button {
        background: none repeat scroll 0 0 #14B9D5;
        border: none;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
        font-family: inherit;
        font-size: 1.3rem;
        font-weight: 700;
        padding: 1rem 2rem;
        text-decoration: none;
    }
    .form-wrap .button:hover {
        background :#0e778a;
    }
    .form-wrap a.button > i {
        font-size: 1.5rem;
        line-height: 0rem;
    }

    .scroll {
        color: #555;
        font-weight: bold;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    }
    .scroll:hover {
        color: #222;
        text-decoration: underline;
    }

    .social {
        width: 100%;
        margin: 1rem;
        display: flex;
        justify-content: space-around;
    }
    .social a {
        display: inline-block;
        min-width: 1rem;
        color: #fff;
        text-decoration: none;
        font-weight: bold;
        border-radius: 4px;
        padding: 0;
    }
    .social a.facebook {
        background: #3b5998;
        &:hover {
            background: #37528c;
        }
    }
    .social .twitter {
        background: #1daee3;
        &:hover {
            background: #1ca4d6;
        }
    }
    .social .google {
        background: #d34836;
        &:hover {
            background: #c74534;
        }
    }
    .social i {
        border-radius: 4px 0 0 4px;
        font-size: 1.3rem;
        padding: 1rem 1.5rem;
        vertical-align: middle;
        clear: both;
    }
    .social .facebook > span,
    .social .twitter > span,
    .social .google > span {
        font-size: 1.5rem;
        line-height: 0rem;
        letter-spacing: 0.06em;
        padding: 2.4rem 2rem 2.4rem 0;
        @media (max-width: 768px) {
            display: none;
        }
    }

    .goto-2 {
        transform: translateX(-33%);
    }
    .goto-3 {
        transform: translateX(-66%);
    }
`